<template>
  <vue-dialog :dialog-data="dialogData" @confirm="confirm">
    <el-form :model="dialogForm" class="label-gray" label-width="120px" :rules="rules" ref="dialogForm">
      <el-form-item label="状态" prop="status" v-if="dialogData.row">
        <el-select v-model="dialogForm.status">
          <el-option v-for="(item, index) in smsTemplateStatus" :key="index" :label="item.msg.replace('已', '')" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="模板类型" prop="type">
        <el-select v-model="dialogForm.type">
          <el-option v-for="(item, index) in smsTemplateType" :key="index" :label="item.msg" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="模板内容" prop="content">
        <el-input v-model="dialogForm.content" :rows="5" type="textarea" maxlength="128" show-word-limit resize="none"/>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input v-model.trim="dialogForm.remark" clearable></el-input>
      </el-form-item>
      <el-form-item label="服务商" prop="provider_id">
        <el-select v-model="dialogForm.provider_id">
          <el-option v-for="(item, index) in dialogData.providerList" :key="index" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="模板编号" prop="template_id">
        <el-input v-model.trim="dialogForm.template_id" clearable></el-input>
      </el-form-item>
    </el-form>
  </vue-dialog>
</template>

<script>
  import {inputEmpty, changeEmpty} from '@utils/validate'
  import {smsTemplateType, smsTemplateStatus} from "@utils/formatList"
  export default {
    name: "templateOperate",
    props: {dialogData: Object},
    data() {
      return {
        smsTemplateType,
        smsTemplateStatus,
        dialogForm: {
          type: "user_login",
          content: "",
          remark: "",
          status: "",
          provider_id: "",
          template_id: "",
          is_default: 1,
        },
        rules: {
          content: [inputEmpty("模板内容")],
          provider_id: [changeEmpty("服务商")],
        },
      }
    },
    created() {
      let row = this.dialogData.row;
      if (row) {
        Object.keys(this.dialogForm).forEach(key => this.dialogForm[key] = this.showData(key, row, ""));
      }
    },
    methods: {
      confirm() {
        let row = this.dialogData.row;
        row ? this.revise(row) : this.add();
      },
      add() {
        this.$refs["dialogForm"].validate(async isOk => {
          if (isOk) {
            let nv = {...this.dialogForm};
            let res = await this.$Http.addSmsTemplate(nv);
            if (res) {
              this.msgSuccess("添加成功");
              this.$emit("table-reload");
              this.dialogData.visible = false;
            }
          }
        });
      },
      revise(row) {
        let nv = {};
        for(let [key, val] of Object.entries(this.dialogForm)) {
          if (val !== this.showData(key, row, "")) {
            nv[key] = val;
          }
        }
        if (Object.keys(nv).length) {
          this.$refs["dialogForm"].validate(isOk => {
            if (isOk) {
              this.openConfirm("修改该模板", async () => {
                nv.optionId = row.id;
                let res = await this.$Http.reviseSmsTemplate(nv);
                if (res) {
                  this.msgSuccess("修改成功");
                  this.$emit("table-reload");
                  this.dialogData.visible = false;
                }
              });
            }
          });
        } else {
          this.msgInfo("您尚未做任何修改")
        }
      },
    }
  }
</script>

<style scoped>

</style>
